import React from 'react'
import { QRCodeCanvas } from 'qrcode.react'
import { useNavigate } from 'react-router-dom'
interface IProps {
  closeModal: () => void
  qrCodeValue: string
}
const QrcodeGenerateModel: React.FC<IProps> = ({ closeModal, qrCodeValue }) => {
  const navigate = useNavigate()
  const handleQrCodeClick = () => {
    // Extract the formId from the QR code value (assuming the formId is at the end of the URL)
    const formId = qrCodeValue.split('/').pop()
    if (formId) {
      // Navigate to the form page using the extracted formId
      navigate(
        `https://botgo.io/${
          process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT
            ? process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT
            : 'dev'
        }/previewChatbot/?formId=${formId}`
      )
    }
  }
  return (
    <div className='card w-300px h-300px mb-4 position-relative text-center'>
      <button
        type='button'
        className='btn-close position-absolute top-0 end-0 m-n4 rounded-circle'
        aria-label='Close'
        onClick={closeModal}
        style={{
          backgroundColor: 'rgba(218, 222, 243)',
          height: '25px',
          width: '25px',
          color: 'rgba(52, 60, 106'
        }}
      ></button>
      <div className='d-flex justify-content-between align-items-center px-3 py-2'>
        <h2 className='mb-0'>Scan QR Code </h2>
      </div>
      <div
        className='d-flex align-items-center justify-content-center mt-10'
        // Attach the handleQrCodeClick function to the onClick event of the QR code
        onClick={handleQrCodeClick}
        style={{ cursor: 'pointer' }}
      >
        {/* Render the QR code using the qrcode.react library */}
        <QRCodeCanvas value={qrCodeValue} size={200} style={{}} />
      </div>
    </div>
  )
}
export default QrcodeGenerateModel
